import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';

import { ActionButton, getActions, type ActionContext } from 'actions';
import { type WorkspaceModel } from './WorkspaceModel';
import { WorkspaceNewObjectMenu } from './WorkspaceNewObjectMenu';

/**
 * The workspace toolbar, spanning the tree and contents panes. Offers creates
 * pre-targeted to the selected container (New Folder + a New Object menu of the
 * folder-scoped types) and shows the contents count.
 */
export const WorkspaceToolbar = observer(({ model }: { readonly model: WorkspaceModel }) => {
  const navigate = useNavigate();
  const createIn = model.createTarget ?? undefined;
  const actions = getActions({ entities: [], refresh: model.refresh, navigate, createIn } satisfies ActionContext);

  // `shown` can read below `total` once fully paged: `total` is the server's
  // count, but the validating union drops any row of a type the frontend hasn't
  // learned yet (intentional). Acceptable until such a type is added.
  const shown = model.folderRows.length + model.contents.items.length;
  const total = model.folderRows.length + model.contents.total;

  return (
    <div className="workspace-toolbar">
      <ActionButton actions={actions} action="createFolder" variant="primary" size="sm" label="New Folder" />
      <WorkspaceNewObjectMenu actions={actions} />
      {model.selected !== null && (
        <span className="ms-auto text-body-tertiary small">{model.contents.loading ? 'Loading…' : `Showing ${shown} of ${total}`}</span>
      )}
    </div>
  );
});
